const prefix = "/admin";

export const route = {
  default: prefix,
  login: prefix + "/login", // 로그인
  // join: prefix + "/join", // 회원가입
  // join_complete: prefix + "/join/complete", // 회원가입 완료

  // -------------------------------------------- 홈 영역 -------------------------------------------- //
  home: prefix + "/home",
  home_empty: prefix + "/main/empty",

  // -------------------------------------------- 쇼핑 영역 -------------------------------------------- //
  shopping: prefix + "/shopping",
  // 상품관리
  shopping_product: prefix + "/shopping/product", // 상품관리 목록
  shopping_product_create_basic: prefix + "/shopping/product/create/basic", // 상품관리 추가하기 - 01. 기본 내용 설정
  shopping_product_create_detail: prefix + "/shopping/product/create/detail", // 상품관리 추가하기 - 02. 상세 내용 설정
  shopping_product_create_chapter: prefix + "/shopping/product/create/chapter", // 상품관리 추가하기 - 03. 목차/커리큘럼 설정
  shopping_product_create_image: prefix + "/shopping/product/create/image", // 상품관리 추가하기 - 04. 썸네일 및 배너 설정
  shopping_product_create_etc: prefix + "/shopping/product/create/etc", // 상품관리 추가하기 - 05. 기타 설정
  shopping_product_edit_basic: prefix + "/shopping/product/edit/basic", // 상품관리 수정하기 - 01. 기본 내용 설정
  shopping_product_edit_detail: prefix + "/shopping/product/edit/detail", // 상품관리 수정하기 - 02. 상세 내용 설정
  shopping_product_edit_chapter: prefix + "/shopping/product/edit/chapter", // 상품관리 수정하기 - 03. 목차/커리큘럼 설정
  shopping_product_edit_image: prefix + "/shopping/product/edit/image", // 상품관리 수정하기 - 04. 썸네일 및 배너 설정
  shopping_product_edit_etc: prefix + "/shopping/product/edit/etc", // 상품관리 수정하기 - 05. 기타 설정
  shopping_product_chapter: prefix + "/shopping/chapter", // 목차/커리큘럼
  shopping_product_chapter_create: prefix + "/shopping/chapter/create", // 목차/커리큘럼 추가하기
  shopping_product_chapter_edit: prefix + "/shopping/chapter/edit", // 목차/커리큘럼 수정하기
  // 판매관리
  shopping_sell: prefix + "/shopping/sell", // 판매관리 목록
  shopping_sell_detail: prefix + "/shopping/sell/detail", // 판매관리 상세페이지
  // 멤버십 상품관리
  shopping_membership_product: prefix + "/shopping/membership/product", // 멤버십 상품관리 수강권
  shopping_membership_product_create:
    prefix + "/shopping/membership/product/create", // 멤버십 상품관리 수강권 추가하기
  shopping_membership_product_edit:
    prefix + "/shopping/membership/product/edit", // 멤버십 상품관리 수강권 수정하기
  shopping_membership_product_lms: prefix + "/shopping/membership/product/lms", // 멤버십 상품관리 멤버십 상품 전자책
  shopping_membership_product_lms_detail:
    prefix + "/shopping/membership/product/lms/detail", // 멤버십 상품관리 멤버십 상품 전자책 상세페이지 - 기본 내용 설정
  shopping_membership_product_lms_curriculum:
    prefix + "/shopping/membership/product/lms/detail/curriculum", // 멤버십 상품관리 멤버십 상품 전자책 상세페이지 - 커리큘럼
  shopping_membership_product_lms_image:
    prefix + "/shopping/membership/product/lms/detail/image", // 멤버십 상품관리 멤버십 상풒 전자책 상세페이지 - 이미지
  // 멤버십 판매관리
  shopping_membership_sell: prefix + "/shopping/membership/sell", // 멤버십 판매관리 목록
  shopping_membership_sell_detail: prefix + "/shopping/membership/sell/detail", // 멤버십 판매관리 상세페이지
  // 후기관리
  shopping_review: prefix + "/shopping/review",

  // -------------------------------------------- 회원 관리 영역 -------------------------------------------- //
  user: prefix + "/user",
  // 회원정보
  user_info: prefix + "/user/info", // 회원정보 목록
  user_info_detail: prefix + "/user/info/detail", // 회원정보 상세페이지
  // 멤버십 회원정보
  user_membership_info: prefix + "/user/membership/info", // 멤버십 회원정보 목록
  user_membership_info_detail: prefix + "/user/membership/info/detail", // 멤버십 회원정보 상세페이지
  // 멤버십 대기명단
  user_membership_waiting_list: prefix + "/user/membership/waiting/list", // 멤버십 대기명단 목록
  user_membership_waiting_list_detail:
    prefix + "/user/membership/waiting/list/detail", // 멤버십 대기명단 상세페이지
  // 무료 PDF 신청 명단
  user_pdf_application_list: prefix + "/user/pdf/application/list", // 무료 PDF 신청 명단 목록
  user_pdf_application_list_detail:
    prefix + "/user/pdf/application/list/detail", // 무료 PDF 신청 명단 상세페이지
  // 운영진 설정
  user_admin: prefix + "/user/admin", // 운영진 설정 목록
  user_admin_detail: prefix + "/user/admin/detail", // 운영진 설정 상세페이지
  user_admin_invite: prefix + "/user/admin/invite", // 운영진 설정 초대 내역
  // 구매제한 회원
  user_purchase_limit: prefix + "/user/purchaseLimit",
  // 탈퇴 회원
  user_withdraw: prefix + "/user/withdraw", // 탈퇴 회원 목록
  user_withdraw_detail: prefix + "/user/withdraw/detail", // 탈퇴 회원 상세페이지

  // -------------------------------------------- 통계 영역 -------------------------------------------- //
  statistics: prefix + "/statistics",
  // 홈
  statistics_home: prefix + "/statistics/home",
  // 매출
  statistics_sales: prefix + "/statistics/sales",
  // 기간별 분석
  statistics_period: prefix + "/statistics/period",
  // 유입 사이트
  statistics_inflow_site: prefix + "/statistics/inflow/site",
  // 유입 검색어
  statistics_inflow_search: prefix + "/statistics/inflow/search",
  // 방문자
  statistics_visitor: prefix + "/statistics/visitor",
  // 많이 방문한 페이지
  statistics_most_visited: prefix + "/statistics/mostVisited",
  // 시간대별 조회수
  statistics_time: prefix + "/statistics/time",
  // 성별·연령별 조회수
  statistics_gender_age: prefix + "/statistics/genderAge",
  // 멤버십 분석
  statistics_analysis: prefix + "/statistics/analysis",
  // 멤버십 해지분석
  statistics_cancel: prefix + "/statistics/cancel",

  // -------------------------------------------- 운영 관리 영역 -------------------------------------------- //
  operation: prefix + "/operation",
  // 쿠폰
  operation_coupon: prefix + "/operation/coupon", // 쿠폰 목록
  operation_coupon_create: prefix + "/operation/coupon/create", // 쿠폰 추가하기
  operation_coupon_edit: prefix + "/operation/coupon/edit", // 쿠폰 수정하기
  // 메시지 보내기
  operation_message: prefix + "/operation/message",
  operation_message_alarm: prefix + "/operation/message/alarm", // 메시지 알림
  operation_message_alarm_detail: prefix + "/operation/message/alarm/detail", // 최근 30일 발송 알림, 발송 예약 알림 상세페이지
  operation_message_email: prefix + "/operation/message/email", // 메시지 이메일
  operation_message_sms: prefix + "/operation/message/sms", // 메시지 SMS
  operation_message_sms_detail: prefix + "/operation/message/sms/detail", // 최근 30일 발송 SMS, 발송 예약 SMS 상세페이지
  // 공지사항 관리
  operation_notice: prefix + "/operation/notice",
  operation_notice_detail: prefix + "/operation/notice/detail", // 공지사항 상세페이지
  operation_notice_create: prefix + "/operation/notice/create", // 공지사항 추가하기
  operation_notice_edit: prefix + "/operation/notice/edit", // 공지사항 수정하기
  // 포인트 관리
  operation_point: prefix + "/operation/point",
  // 레벨 설정 관리
  operation_level: prefix + "/operation/level",
  // 자주 묻는 질문 관리
  operation_faq: prefix + "/operation/faq",
  operation_faq_detail: prefix + "/operation/faq/detail", // 자주 묻는 질문 상세페이지
  operation_faq_create: prefix + "/operation/faq/create", // 자주 묻는 질문 추가하기
  operation_faq_edit: prefix + "/operation/faq/edit", // 자주 묻는 질문 수정하기
  // 1:1 문의 내역 관리
  operation_ask: prefix + "/operation/ask",
  operation_ask_detail: prefix + "/operation/ask/detail", // 1:1 문의 상세페이지
  // 팝업/배너 관리
  operation_popup_banner: prefix + "/operation/popupBanner",
  operation_popup_banner_create: prefix + "/operation/popupBanner/create", // 팝업/배너 추가하기
  operation_popup_banner_edit: prefix + "/operation/popupBanner/edit", // 팝업/배너 수정하기
  // 약관 관리
  operation_terms: prefix + "/operation/terms",
  // 데이터 연결
  operation_data: prefix + "/operation/data",
  // 상담채널 연동
  operation_consult: prefix + "/operation/consult",

  // -------------------------------------------- 일급비밀 관리 영역 -------------------------------------------- //
  secret: prefix + "/secret",
  // 일급비밀 상세페이지
  secret_detail: prefix + "/secret/detail", // 일급비밀 상세페이지 - 기본 내용 설정
  secret_detail_curriculum: prefix + "/secret/detail/curriculum", // 일급비밀 상세페이지 - 커리큘럼
  secret_detail_image: prefix + "/secret/detail/image", // 일급비밀 상세페이지 - 이미지
  // 멤버십 QnA 관리
  secret_qna: prefix + "/secret/qna", // 멤버십 QnA 목록
  secret_qna_detail: prefix + "/secret/qna/detail", // 멤버십 QnA 상세페이지
  secret_qna_edit: prefix + "/secret/qna/edit", // 멤버십 QnA 수정하기
  // 자료창고 관리
  secret_archive: prefix + "/secret/archive", // 자료창고 목록
  secret_archive_detail: prefix + "/secret/archive/detail", // 자료창고 상세페이지
  secret_archive_edit: prefix + "/secret/archive/edit", // 자료창고 수정하기

  // -------------------------------------------- 지식상점 관리 영역 -------------------------------------------- //
  knowledge: prefix + "/knowledge",
  // 지식상점 홈 배너
  knowledge_banner: prefix + "/knowledge/banner",
  // Vu: 관리
  knowledge_vu: prefix + "/knowledge/vu",
  knowledge_vu_create: prefix + "/knowledge/vu/create", // Vu: 추가하기
  knowledge_vu_edit: prefix + "/knowledge/vu/edit", // Vu: 수정하기
  // 커리큘럼 관리
  knowledge_curriculum: prefix + "/knowledge/curriculum",
  knowledge_curriculum_create: prefix + "/knowledge/curriculum/create", // 커리큘럼 추가하기
  knowledge_curriculum_edit: prefix + "/knowledge/curriculum/edit", // 커리큘럼 수정하기
  // 첫 방문이라면? 관리
  knowledge_first_visit: prefix + "/knowledge/firstVisit",

  // -------------------------------------------- 커뮤니티 관리 영역 -------------------------------------------- //
  community: prefix + "/community",
  // 커뮤니티 관리
  community_management: prefix + "/community/management", // 커뮤니티 관리 목록
  community_management_detail: prefix + "/community/management/detail", // 커뮤니티 상세페이지
  // 라이팅크루가 처음이라면?
  community_first: prefix + "/community/first",
  community_first_create: prefix + "/community/first/create", // 라이팅크루가 처음이라면? 추가하기
  community_first_edit: prefix + "/community/first/edit", // 라이팅크루가 처음이라면? 추가하기

  // -------------------------------------------- 멤버십 전용 관리 영역 -------------------------------------------- //
  crew: prefix + "/crew",
  // 멤버십 가이드
  crew_guide: prefix + "/crew/guide",
  crew_guide_create: prefix + "/crew/guide/create", // 멤버십 가이드 추가하기
  crew_guide_edit: prefix + "/crew/guide/edit", // 멤버십 가이드 수정하기
  // 라이팅링크
  crew_link: prefix + "/crew/link", // 라이팅링크 목록
  crew_link_detail: prefix + "/crew/link/detail", // 라이팅링크 상세페이지
};
